var _path, _path2, _line, _line2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrinters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.1C16 2.04477 15.9552 2 15.9 2H6.1C6.04477 2 6 2.04477 6 2.1V6.7125C6 6.76773 6.04477 6.8125 6.1 6.8125H7.32857C7.3838 6.8125 7.42857 6.85727 7.42857 6.9125V9.87977C7.42857 9.91549 7.44763 9.9485 7.47856 9.96637L10.95 11.9711C10.9809 11.989 11.0191 11.989 11.05 11.9711L14.5214 9.96637C14.5524 9.9485 14.5714 9.9155 14.5714 9.87977V6.9125C14.5714 6.85727 14.6162 6.8125 14.6714 6.8125H15.9C15.9552 6.8125 16 6.76773 16 6.7125V2.1Z",
    stroke: "#003393",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5V16C11 17.6569 9.65685 19 8 19H1",
    stroke: "#003393",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 4,
    x2: 1,
    y2: 4,
    stroke: "#003393",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 4,
    x2: 17,
    y2: 4,
    stroke: "#003393",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinters);
export default __webpack_public_path__ + "static/media/printers.56c1365a72a6714121d35decbbd94ce0.svg";
export { ForwardRef as ReactComponent };